<div >
  <div class="modal-header modal-header-pb">      
    <h4 class="ct-modal-tittle">Send to CT Global</h4>  
  </div>
  <div class="modal-body carrier-modal-body">  
    <div  class="carrier-modal-div" >
      <h1 class="carrier-modal-h1">​You're about to <b>Send Comment to CT Global</b> as an action?</h1>
    </div>
  </div>
  <div class="modal-footer att-modal-footer">
    <button type="button" class="btn btn-info btn-secondary btn-modal-footer-ok" (click)="confirm()" >Ok</button>
    <button type="button" class="btn btn-info btn-secondary btn-modal-footer-x" (click)="dismiss()">Cancel</button>
  </div>
</div>
  